import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { BellRing, Lock } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Switch } from './ui/switch';
import { Button } from './ui/button';
import { pushSupported, isIOS, isStandalone, enablePush } from '../lib/push';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const PushPrefsDialog = ({ open, onOpenChange }) => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => axios.get(`${API_URL}/push/prefs`).then((r) => setData(r.data)).catch(() => setData(null));
  useEffect(() => { if (open) load(); }, [open]);

  const toggle = async (key, enabled) => {
    const groups = data.groups.map((g) => (g.key === key ? { ...g, enabled } : g));
    setData({ ...data, groups });
    const body = Object.fromEntries(groups.filter((g) => !g.locked).map((g) => [g.key, g.enabled]));
    try { await axios.put(`${API_URL}/push/prefs`, body); } catch { toast.error('Erro ao guardar'); load(); }
  };
  const activate = async () => {
    setBusy(true);
    try { await enablePush(); toast.success('Notificações ativas neste dispositivo'); load(); } catch (e) {
      toast.error(e.message === 'Permissão recusada' ? 'Permissão recusada nas definições do navegador' : 'Não foi possível ativar');
    } finally { setBusy(false); }
  };
  const granted = pushSupported() && Notification.permission === 'granted';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="push-prefs-dialog" aria-describedby={undefined}>
        <DialogHeader><DialogTitle className="flex items-center gap-2"><BellRing className="w-5 h-5" />Avisos no telefone</DialogTitle></DialogHeader>
        <div className="rounded-xl bg-slate-50 border border-slate-200 p-3 text-sm flex items-center justify-between gap-2" data-testid="push-prefs-device">
          <span>{data ? `${data.devices} dispositivo(s) ativo(s)` : '…'}{granted ? ' · este dispositivo ativo' : ''}</span>
          {isIOS() && !isStandalone() ? (
            <span className="text-xs text-slate-500">No iPhone: Partilhar → Adicionar ao ecrã principal</span>
          ) : pushSupported() && (
            <Button size="sm" variant="outline" disabled={busy} onClick={activate} data-testid="push-prefs-activate">{granted ? 'Enviar teste' : 'Ativar aqui'}</Button>
          )}
        </div>
        <div className="divide-y divide-slate-100">
          {(data?.groups || []).map((g) => (
            <label key={g.key} className="flex items-center justify-between gap-3 py-3 text-sm" data-testid={`push-pref-${g.key}`}>
              <span className="flex items-center gap-1.5">{g.locked && <Lock className="w-3.5 h-3.5 text-slate-400" />}{g.label}</span>
              <Switch checked={g.enabled} disabled={g.locked} onCheckedChange={(v) => toggle(g.key, v)} data-testid={`push-pref-switch-${g.key}`} />
            </label>
          ))}
        </div>
        <p className="text-[11px] text-slate-500">Os avisos desligados continuam a aparecer no sino do CRM, só não tocam no telefone.</p>
      </DialogContent>
    </Dialog>
  );
};
